import { unitId, actionId } from '@/annotations'
import { AuthCard } from '@/components/AuthCard'
import { AuthCardBrand } from '@/components/AuthCardBrand'
import { AuthCardLead } from '@/components/AuthCardLead'
import { Strip } from '@/components/Strip'
import { AUTH_BRAND, A_INVITEDEAD_COPY } from '@/copy/registry'

/** `a-invitedead` — one landing for four causes (§3.1i rule 12). "This screen IS that call's
 * landing. Nothing on it calls anything" (process/09-SCREEN-SPECS/a-invitedead.md). */
export function AInvitedead({ onBackToSignIn }: { onBackToSignIn: () => void }) {
  return (
    <AuthCard unitId={unitId('a-invitedead')}>
      <AuthCardBrand label={AUTH_BRAND} />
      <h3 className="m-0 mb-3 text-section font-semibold">{A_INVITEDEAD_COPY.heading}</h3>
      <AuthCardLead>{A_INVITEDEAD_COPY.lead}</AuthCardLead>
      <div className="my-14">
        <Strip>{A_INVITEDEAD_COPY.uniformLandingStrip}</Strip>
      </div>
      <p>
        <a href="#" data-act={actionId('nav.a-signin')} onClick={(e) => { e.preventDefault(); onBackToSignIn() }} className="text-link text-small">
          {A_INVITEDEAD_COPY.backToSignInLabel}
        </a>
      </p>
    </AuthCard>
  )
}
